module.exports = __webpack_public_path__ + "img/xcx-tgo.c07c74a5.jpg";